import { useTranslation } from "react-i18next";
import { Route, Routes } from "react-router-dom";

import { ErrorTypes } from "../shared/errorTypes";
import { ConnectedConfigWizardLazy } from "./config-wizard/ConnectedConfigWizard.lazy";
import { ConnectedGenericErrorPageLazy } from "./error-screens/ConnectedGenericErrorPage.lazy";
import { ConnectedPatientLobbyLazy } from "./patient-lobby/ConnectedPatientLobby.lazy";
import { ConnectedProviderSignInLazy } from "./provider-signin/ConnectedProviderSignIn.lazy";

export const RouteSwitcher = (): JSX.Element => {
  const { t } = useTranslation();

  const Appointments = () => {
    document.title = t("Microsoft Teams EHR Queue");
    return <ConnectedConfigWizardLazy nameOfRoute={"appointments"} />;
  };
  const PatientLobby = () => {
    document.title = t("Connect to Microsoft Teams");
    return <ConnectedPatientLobbyLazy />;
  };
  const PractitionerSignIn = (props: any) => {
    document.title = t("Connect to Microsoft Teams");
    return <ConnectedProviderSignInLazy {...props} />;
  };
  const Error = (props: any) => {
    document.title = t("Connect to Microsoft Teams");
    return <ConnectedGenericErrorPageLazy {...props} />;
  };
  const Home = () => {
    document.title = t("Connect to Microsoft Teams");
    return <ConnectedConfigWizardLazy />;
  };
  const Default = (props: any) => {
    document.title = t("Connect to Microsoft Teams");
    return (
      <ConnectedGenericErrorPageLazy
        {...props}
        errorCode={ErrorTypes.PAGE_NOT_FOUND}
      />
    );
  };
  return (
    <Routes>
      <Route path="/appointments" element={<Appointments />} />
      <Route path="/patientLobby" element={<PatientLobby />} />
      <Route path="/practitionerSignIn" element={<PractitionerSignIn />} />
      <Route path="/error" element={<Error />} />
      <Route path="/" element={<Home />} />
      <Route path="*" element={<Default />} />
    </Routes>
  );
};
